export const ErrorHandlerMixin = {
    data() {
        return {
            error_response: 'An unexpected error occurred during the request.',
            error_code: undefined,
            errors_collection: {},
        };
    },
    mounted() {
        this.resetErrorHandler();
    },
    methods: {
        errorHandlerResult(errors) {
            this.resetErrorHandler();

            if (!errors.response || !errors.response.status) {
                return this.getErrorHandlerResult();
            }

            switch (errors.response.status) {
                case 401:
                    window.location.href = '/login';

                    break;

                case 403:
                    this.error_response = 'You don\'t seem to have the right permissions to make this request.';

                    break;

                case 404:
                    this.error_response = "We couldn't find the resource you were looking for.";

                    break;

                case 419:
                    window.location.href = '/login';

                    break;

                case 422:
                    if (errors.response.data && errors.response.data.errors) {
                        this.error_response = Object.values(errors.response.data.errors)[0][0];
                        this.errors_collection = errors.response.data.errors;
                    } else {
                        this.error_response = 'One or more fields have errors';
                    }

                    break;

                case 429:
                    this.error_response = 'Too many requests, please try again after a while.';

                    break;

                default:
                    this.error_response = `An unexpected error occurred during the request${
                        errors.response.status ? ' (code: ' + errors.response.status + ')' : ''
                    }.`;
            }

            this.error_code = errors.response.status;

            return this.getErrorHandlerResult();
        },

        resetErrorHandler() {
            this.error_response = 'An unexpected error occurred during the request.';
            this.error_code = undefined;
            this.errors_collection = {};
        },

        getErrorHandlerResult() {
            return {
                message: this.error_response,
                code: this.error_code,
                errors: this.errors_collection,
            };
        },
    },
};
